export default defineNuxtRouteMiddleware((to, from) => {
  const localeRoute = useLocaleRoute()
  if (to.path === '/hub/' || to.path === '/hub') {
    return navigateTo(localeRoute('/hub/dashboard'), { redirectCode: 301 })
  }

  if (to.path === '/portal/' || to.path === '/portal') {
    return navigateTo(localeRoute('/portal/dashboard'), { redirectCode: 301 })
  }
})
